import { cx } from "./lib/cx.ts";

/** A grey placeholder bar for content that is still loading. Rule: match the height of what will replace it so nothing jumps. */
export function Skeleton({ height = 44, class: className }: { height?: number; class?: string }) {
  return <div class={cx("ui-skeleton", className)} style={{ height: `${height}px` }} aria-hidden="true" />;
}
